import { State } from "@features/base/types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  CashRegisterParameters,
  CashRegister,
  CashRegistersResponse,
  getCashRegistersApi,
} from "./api";

export const getCashRegisters = createAsyncThunk<
  CashRegistersResponse,
  { userId: string; data?: CashRegisterParameters }
>(
  "cashRegisters/getCashRegisters",
  async ({ userId, data }, { rejectWithValue }) => {
    try {
      return await getCashRegistersApi(userId, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

type CashRegisterState = State<{
  caches: CashRegister[] | null;
  page: number;
  count: number;
}>;

const initialState: CashRegisterState = {
  caches: null,
  loading: false,
  error: null,
  page: 1,
  count: 0,
};

const cashRegistersSlice = createSlice({
  name: "cashRegisters",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCashRegisters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCashRegisters.fulfilled, (state, action) => {
        state.loading = false;
        state.page = action.payload.page;
        state.caches = action.payload.caches;
        state.count = action.payload.count;
      })
      .addCase(getCashRegisters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default cashRegistersSlice.reducer;
